// /frontend/src/pages/ReturnsPage.jsx
import React from 'react';
import Layout from '../components/layout/Layout';

const ReturnsPage = () => {
  return (
    <Layout>
      <div className="max-w-4xl mx-auto px-4 py-12">
        <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8">Returns & Refunds</h1>
        
        <div className="prose prose-lg max-w-none">
          <p className="text-lg mb-6">
            At Henderson Design Group, we want you to be completely satisfied with your purchase. We understand that sometimes a product may not meet your expectations, which is why we offer a straightforward returns policy.
          </p>
          
          <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-4">Return Eligibility</h2>
          <p className="mb-6">
            Custom orders, Furniture Packages, and personalized items cannot be returned unless there is a manufacturing defect. Stock furniture items may be eligible for return under the following conditions:
          </p>
          <ul className="list-disc pl-6 mb-6">
            <li className="mb-2">Return request is made within 14 days of delivery</li>
            <li className="mb-2">Items are in original condition, unused, and with all original packaging</li>
            <li className="mb-2">All tags and protective coverings are intact</li>
            <li className="mb-2">You have proof of purchase (order confirmation or receipt)</li>
          </ul>
          
          <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-4">Non-Returnable Items</h2>
          <p className="mb-4">
            The following items cannot be returned:
          </p>
          <ul className="list-disc pl-6 mb-6">
            <li className="mb-2">Custom or made-to-order furniture</li>
            <li className="mb-2">Furniture Packages (as these are specifically curated)</li>
            <li className="mb-2">Items marked as final sale</li>
            <li className="mb-2">Items that have been used, assembled, or modified</li>
            <li className="mb-2">Items with removed tags or packaging</li>
          </ul>
          
          <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-4">Return Process</h2>
          <ol className="list-decimal pl-6 mb-6">
            <li className="mb-2">Contact our customer service at <a href="mailto:aloha@henderson.house" className="text-teal-700 hover:text-teal-900">aloha@henderson.house</a> within 14 days of delivery</li>
            <li className="mb-2">Include your order number and reason for return</li>
            <li className="mb-2">Our team will evaluate your request and provide further instructions</li>
            <li className="mb-2">If approved, we'll arrange for pickup or provide return shipping instructions</li>
            <li className="mb-2">Once we receive and inspect the returned items, a refund will be processed</li>
          </ol>
          
          <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-4">Refund Policy</h2>
          <p className="mb-6">
            Refunds will be issued to the original payment method. Please allow 10-14 business days for your refund to process after we've received and inspected the returned items.
          </p>
          
          <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-4">Return Shipping</h2>
          <p className="mb-6">
            For returnable items, return shipping fees are the responsibility of the customer unless the return is due to a manufacturing defect or our error. Return shipping will be arranged by our logistics team, and the cost will be deducted from your refund.
          </p>
          
          <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-4">Damaged or Defective Items</h2>
          <p className="mb-6">
            If you receive a damaged or defective item, please contact us within 48 hours of delivery with photos of the damage. We'll work with you to resolve the issue promptly, which may include repair, replacement, or refund.
          </p>
          
          <div className="bg-gray-50 p-6 rounded-lg border border-gray-200 mt-10">
            <h3 className="text-xl font-bold text-gray-900 mb-3">Questions About Returns?</h3>
            <p className="mb-4">
              Our customer service team is available to assist you with any questions regarding returns and refunds. Contact us at <a href="tel:+18083158782" className="text-teal-700 hover:text-teal-900">808.315.8782</a> or <a href="mailto:aloha@henderson.house" className="text-teal-700 hover:text-teal-900">aloha@henderson.house</a>.
            </p>
            <p className="text-sm text-gray-500">
              Please note: We require 3 months lead time for all installations.
            </p>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ReturnsPage;